<mat-form-field>
  <mat-label>Select a Task Group</mat-label>
  <mat-select [disabled]="disabled" [(value)]="groupId">
    <mat-option>
      <ngx-mat-select-search [formControl]="groupFilterCtrl" placeholderLabel="Search..." noEntriesFoundLabel="No matches"></ngx-mat-select-search>
    </mat-option>
    @for (h of filteredGroups; track h) {
      <mat-option [value]="h.uid">{{h.name}}{{ h.completed ? ' (Completed)' : ''}}</mat-option>
    }
  </mat-select>
</mat-form-field>